import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MentisWordmark } from "@/components/MentisMark";
import {
  GoalStrip, HealthBar, PathwayRoadmap, ProgramMatchCard, CompetencyDetail,
} from "@/components/mentis/WorkspaceCards";
import { api } from "@/lib/api";

export default function ShareView() {
  const { sid } = useParams();
  const [session, setSession] = useState(null);
  const [selected, setSelected] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { api.getSession(sid).then(setSession).catch(() => setErr(true)); }, [sid]);

  if (err) return <div className="App min-h-screen flex items-center justify-center text-slate-700">This pathway link is no longer available.</div>;
  if (!session) return <div className="App min-h-screen flex items-center justify-center text-slate-700">Loading pathway…</div>;

  return (
    <div className="App min-h-screen">
      <header className="h-16 border-b border-black/[0.08] bg-[#FAF9F7]/85 backdrop-blur-md sticky top-0 z-50">
        <div className="h-full px-5 sm:px-8 flex items-center justify-between max-w-[1100px] mx-auto">
          <Link to="/"><MentisWordmark /></Link>
          <Link to="/" data-testid="share-build-cta"
            className="btn-orange rounded-full px-4 py-2 text-sm font-semibold flex items-center gap-2">
            Build your own path <ArrowRight size={15} />
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-10" data-testid="share-view">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="mb-6">
          <div className="mono-label text-orange-600 mb-2">Shared with you · Built by Mentis</div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900 tracking-tight">
            {session.learner?.name && session.learner.name.toLowerCase() !== "not provided"
              ? `${session.learner.name}'s Pathway` : "A Mentogram Pathway"}
          </h1>
        </motion.div>

        <div className="space-y-5">
          {session.goal?.identified && <GoalStrip goal={session.goal} learner={session.learner} />}
          {session.program_match && <ProgramMatchCard match={session.program_match} />}
          {session.pathway ? (
            <>
              <HealthBar health={session.pathway.health} />
              <PathwayRoadmap pathway={session.pathway} onSelect={setSelected} />
            </>
          ) : (
            <div className="surface rounded-2xl p-8 text-center text-slate-700">This pathway is still being built.</div>
          )}
        </div>
      </main>
      <CompetencyDetail comp={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
